import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const brakefluidAuthorisedService = {
    getAllAuthoriseds,
    getAuthorised,
    updateAuthorised,
    createAuthorised,
    updateAuthorisedStatus 
};

const MODULE = {
  AUTHORISED: 'brake-fluid-authoriseds',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllAuthoriseds(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.AUTHORISED}`, requestOptions)
  }

  export function getAuthorised(id) {
    return apiHelper(API_URL).get(`/${MODULE.AUTHORISED}/${id}`)
  }

  export function updateAuthorised(data) {

    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.AUTHORISED}/${data.id}`, requestOptions)
  }

  export function createAuthorised(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.AUTHORISED}`, requestOptions)
  }

  export function updateAuthorisedStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
  
    return apiHelper(API_URL).patch(`/${MODULE.AUTHORISED}/${data.id}`, requestOptions)
  }